import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import { AiOutlineSearch, AiOutlineMenu } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import { GrClose } from "react-icons/gr";
// import images
import LogoImg from "../../images/contact/Marke.png";
import img1 from "../../images/compare.svg";
import img2 from "../../images/wishlist.svg";
import img3 from "../../images/user.svg";
import img4 from "../../images/cart.svg";
import menu from "../../images/menu.svg";
import { useSelector } from "react-redux";
const Header = () => {
  const [showul, setshowul] = useState(false);
  // show loader
  const [loader, showloader] = useState(false);
  const showloaderr = () => {
    showloader(true);
    setTimeout(() => {
      showloader(false);
    }, 1200);
    window.scrollTo(0, 0);
  };
  const cart = useSelector((state) => state.cart);
  const total = cart.reduce((acc, product) => {
    acc += +product.price.slice(0, 2) * product.quantity;
    return acc;
  }, 0);

  // small devices navbar
  const [smallnav, showsmallnav] = useState(false);

  return (
    <>
      {loader && (
        <div className="mainloader">
          <span className="Circleloader"></span>
        </div>
      )}
      <div
        className="top_Header py-3"
        style={{
          backgroundColor: "#131921",
          borderBottom: "1px solid #3b4149",
        }}
      >
        <div className="container-fluid">
          <div
            className="Hotline_div"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <p className="text-white mb-0">
              Free Shipping Over $100 & Free Returns
            </p>
            <p className="text-end text-white mb-0">
              Hotline:
              <a className="text-white" href="tel:+918264542">
                +918264542{" "}
              </a>
            </p>
          </div>
        </div>
      </div>
      {/* start bottom header */}
      <header
        className="bottom_header py-2"
        style={{ backgroundColor: "#131921" }}
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-2">
              <h1>
                <Link to="/" onClick={() => showloaderr()}>
                  Marketo .
                </Link>
              </h1>
            </div>
            <div className="col-lg-5">
              <div className="input-group ">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Product Here ..."
                  aria-label="Search Product Here ..."
                  aria-describedby="basic-addon2"
                  style={{ outline: "none" }}
                />
                <span
                  className="input-group-text "
                  id="basic-addon2"
                  style={{ backgroundColor: "#FEBD69", cursor: "pointer" }}
                >
                  <AiOutlineSearch className="fs-5" />
                </span>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="header-links d-flex align-items-center justify-content-between">
                <div>
                  <Link to="/OurStore" onClick={() => showloaderr()}>
                    <img src={img1} alt="hedaer_links"></img>
                    <Link to="/OurStore" className="mb-0">
                      Compare <br></br>Products
                    </Link>
                  </Link>
                </div>
                <div>
                  <Link to="/Cart" onClick={() => showloaderr()}>
                    <img src={img2} alt="hedaer_links"></img>
                    <Link to="/Cart" className="mb-0">
                      Favourite<br></br>
                      Wishlist
                    </Link>
                  </Link>
                </div>

                <div>
                  <Link to="/Account" onClick={() => showloaderr()}>
                    <img src={img3} alt="hedaer_links"></img>
                    <Link to="/Account" className="mb-0">
                      Log In<br></br>
                      My Account
                    </Link>
                  </Link>
                </div>

                <div>
                  <Link to="/Cart" onClick={() => showloaderr()}>
                    <img src={img4} alt="hedaer_links"></img>
                    <div className="d-flex flex-column">
                      <small className="badge bg-white text-dark text-bold">
                        {cart.length}
                      </small>
                      <Link
                        to="/Cart"
                        className="mb-0"
                        onClick={() => showloaderr()}
                      >
                        ${total}
                      </Link>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        className="header-botton py-1"
        style={{ backgroundColor: "#232F3E" }}
      >
        <div className="menu-bottom d-flex align-items-center ">
          <div>
            <div className="dropdown">
              <a
                className="btn btn-secondary dropdown-toggle"
                href="btn"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  <img src={menu} alt="menu"></img>&nbsp;&nbsp;SHOP CATEGORIES
                </span>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Mobile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Televisions
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Headphobes
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Homeappliances
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Computers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Cameras
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Kitchen
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Personalcare
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="/OurStore"
                    onClick={() => showloaderr()}
                  >
                    Accessories
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* start small devices div */}
          <div className="small_device">
            <AiOutlineMenu onClick={() => showsmallnav(!smallnav)} />
            {smallnav && (
              <div className="small_devicelinks">
                <div className="header">
                  <img src={LogoImg} alt="navimg"></img>
                  <GrClose onClick={() => showsmallnav(!smallnav)} />
                </div>
                <p>
                  Discover the most outstanding articles on all topics of life.
                  Write your stories and share them
                </p>
                <div className="search">
                  <AiOutlineSearch />
                  <input type={"text"} placeholder="Type something"></input>
                </div>
                <div className="mobile_links">
                  <NavLink
                    to="/"
                    onClick={() => {
                      showloaderr();
                      showsmallnav(!smallnav);
                    }}
                  >
                    Home
                  </NavLink>
                  <NavLink
                    to="/OurStore"
                    onClick={() => {
                      showloaderr();
                      showsmallnav(!smallnav);
                    }}
                  >
                    Our Store
                  </NavLink>
                  <NavLink
                    to="/About"
                    onClick={() => {
                      showloaderr();
                      showsmallnav(!smallnav);
                    }}
                  >
                    About
                  </NavLink>
                  <a
                    href="explore"
                    className="Explore"
                    onClick={(e) => e.preventDefault()}
                  >
                    Explore&nbsp;{" "}
                    <BsChevronDown
                      onClick={() => setshowul(!showul)}
                      style={{ float: "right" }}
                    />
                    {showul && (
                      <ul>
                        <li>
                          <Link
                            to="/Faqs"
                            onClick={() => {
                              setshowul(!showul);
                              showloaderr();
                              showsmallnav(!smallnav);
                            }}
                          >
                            Faqs
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/Termsandcondition"
                            onClick={() => {
                              setshowul(!showul);
                              showloaderr();
                              showsmallnav(!smallnav);
                            }}
                          >
                            Terms-and-condition
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/Account"
                            onClick={() => {
                              setshowul(!showul);
                              showloaderr();
                              showsmallnav(!smallnav);
                            }}
                          >
                            Account
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/Cart"
                            onClick={() => {
                              setshowul(!showul);
                              showloaderr();
                              showsmallnav(!smallnav);
                            }}
                          >
                            Cart
                          </Link>
                        </li>
                      </ul>
                    )}
                  </a>
                  <NavLink
                    to="/contact"
                    onClick={() => {
                      showloaderr();
                      showsmallnav(!smallnav);
                    }}
                  >
                    Contact
                  </NavLink>
                </div>
              </div>
            )}
          </div>
          <div className="menu_links d-flex jusify-space-between align-items-center gap-15">
            <NavLink to="/" onClick={() => showloaderr()}>
              Home
            </NavLink>
            <NavLink to="/OurStore" onClick={() => showloaderr()}>
              Our Store
            </NavLink>
            <NavLink to="/About" onClick={() => showloaderr()}>
              About
            </NavLink>
            <a
              href="explore"
              className="Explore"
              onClick={(e) => e.preventDefault()}
            >
              Explore&nbsp; <BsChevronDown onClick={() => setshowul(!showul)} />
              {showul && (
                <ul>
                  <li>
                    <Link
                      to="/Faqs"
                      onClick={() => {
                        setshowul(!showul);
                        showloaderr();
                      }}
                    >
                      Faqs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Termsandcondition"
                      onClick={() => {
                        setshowul(!showul);
                        showloaderr();
                      }}
                    >
                      Terms-and-condition
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Account"
                      onClick={() => {
                        setshowul(!showul);
                        showloaderr();
                      }}
                    >
                      Account
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Cart"
                      onClick={() => {
                        setshowul(!showul);
                        showloaderr();
                      }}
                    >
                      Cart
                    </Link>
                  </li>
                </ul>
              )}
            </a>
            <NavLink to="/contact" onClick={() => showloaderr()}>
              Contact
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
